var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:document-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.7875 30.6375L33.25 44.175H27.7875V38.7125L41.325 25.175L46.7875 30.6375ZM54.8625 28.7375C54.8625 29.45 54.15 30.1625 53.4375 30.875L47.5 36.8125L45.3625 34.675L51.5375 28.5L50.1125 27.075L48.45 28.7375L42.9875 23.275L48.2125 18.2875C48.6875 17.8125 49.6375 17.8125 50.35 18.2875L53.675 21.6125C54.15 22.0875 54.15 23.0375 53.675 23.75C53.2 24.225 52.725 24.7 52.725 25.175C52.725 25.65 53.2 26.125 53.675 26.6C54.3875 27.3125 55.1 28.025 54.8625 28.7375ZM7.125 47.5V9.5H23.75V21.375H35.625V24.9375L40.375 20.1875V19L26.125 4.75H7.125C4.5125 4.75 2.375 6.8875 2.375 9.5V47.5C2.375 50.1125 4.5125 52.25 7.125 52.25H35.625C38.2375 52.25 40.375 50.1125 40.375 47.5H7.125ZM26.125 40.6125C25.65 40.6125 25.175 40.85 24.9375 40.85L23.75 35.625H20.1875L15.2 39.6625L16.625 33.25H13.0625L10.6875 45.125H14.25L21.1375 38.95L22.5625 44.4125H24.9375L26.125 44.175V40.6125Z",
    fill: "#FF3D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.6a91cd5a39ea782bf7ec696552aa49d8.svg";
export { ForwardRef as ReactComponent };